/**
 * 판정 기록 목록 필터 바·페이지 — styled.
 * @spec:2026-09-29-처방검토-판정기록-조회화면
 */
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

export const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 12px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 12px;
  align-items: flex-start;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
`;

export const Hint = styled.div`
  font-size: 11px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
`;

export const ErrorMsg = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Red")?.[400]};
`;

export const Checks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CheckLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
`;

export const TextInput = styled.input`
  height: 34px;
  padding: 0 10px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 8px;
  font-size: 14px;
`;

export const Select = styled.select`
  height: 34px;
  padding: 0 8px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 8px;
  font-size: 14px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[0]};
`;

export const PageWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
`;

export const PageTitle = styled.h1`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: ${COLOR_SYSTEM.get("Gray")?.[900]};
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Pager = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 0;
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
`;
